<template>
  <div class="scheduler_section">
    <div class="scheduler_types">
      <span class="scheduler_type" :class="{ active_item: scheduler.type === 'milestone' }" v-on:click="changeType('milestone')">
        <span class="type_icon_bg">
          <i class="fa fa-flag-o" aria-hidden="true"></i>
        </span>
        &nbsp; Milestones
      </span>
      <span class="scheduler_type" :class="{ active_item: scheduler.type === 'custom' }" v-on:click="changeType('custom')">
        <span class="type_icon_bg">
          <i class="fa fa-sliders" aria-hidden="true"></i>
        </span>
        &nbsp; Custom frequency
      </span>
    </div>
    <div class="pt-40" v-if="scheduler.type === 'milestone'">
      <div v-if="studyData.milestones && studyData.milestones.length > 0">
        <div class="scheduler-heading  pb-5">
          Which milestones will your participants take this survey?
          <span class="edit_milestone_link" v-on:click="updateMilestones()">Edit milestones</span>
        </div>

        <div v-if="studyData.screeningMilestoneAllowed">
          <div :class="[scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? 'milestone_card' : 'selected_completion_window']" :key="index" v-for="(milestone, index) in screeningMilestones">
            <div v-if="scheduler.milestones && milestone.isDoNotShowTimeline" class="notShownCSS" :class="[scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? '' : 'selectedNotShownCSS']">Not shown</div>
            <div class="day_card" v-on:click="selectUnselectMileStone(milestone.milestoneDay, milestone.milestoneType)">
              <p class="m-0">{{ milestone.milestoneName }}</p>
              <p class="m-0 day_text">Day {{ milestone.milestoneDay }}</p>
              <i v-if="scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0" class="fa fa-check-circle" aria-hidden="true"></i>
              <div class="day_text position-relative" v-if="milestone.segments && milestone.segments.length > 0">
                <span class="cursor_pointer CohortDIV dropdown-toggle">{{ milestone.segments.length }} Cohorts</span>
                <div class="dropdown-menu cohortDrop Cohort_hide" disabled aria-labelledby="dropdownMenuLink">
                  <div class="dropdown-item" href="#">
                    <span class="d-block" v-for="cohort in milestone.segments" :key="cohort"> {{ getCohortName(cohort) }}</span>
                  </div>
                </div>
              </div>

              <div v-else>
                <span>
                  All Participants
                </span>
              </div>
            </div>

            <div class="completion-window  d-flex justify-content-between" v-if="scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0">
              <p class="">Completion Window</p>
              <input type="number" placeholder="1 day" v-model="scheduler.completionWindows[milestone.milestoneDay]" v-on:blur="setCompletionWindows(milestone, scheduler.completionWindows[milestone.milestoneDay])" />
            </div>
          </div>
        </div>
        <div :class="[scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? 'milestone_card' : 'selected_completion_window']" :key="index" v-for="(milestone, index) in regularMilestones">
          <div v-if="scheduler.milestones && milestone.isDoNotShowTimeline" class="notShownCSS" :class="[scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? '' : 'selectedNotShownCSS']">Not shown</div>
          <div class="day_card" v-on:click="selectUnselectMileStone(milestone.milestoneDay)">
            <p class="m-0">Milestone {{ index + 1 }}</p>
            <p class="m-0 day_text">Day {{ milestone.milestoneDay }}</p>
            <i v-if="scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0" class="fa fa-check-circle" aria-hidden="true"></i>
            <div class="day_text position-relative" v-if="milestone.segments && milestone.segments.length > 0">
              <span class="cursor_pointer CohortDIV dropdown-toggle">{{ milestone.segments.length }} Cohorts</span>
              <div class="dropdown-menu cohortDrop Cohort_hide" disabled aria-labelledby="dropdownMenuLink">
                <div class="dropdown-item" href="#">
                  <span class="d-block" v-for="cohort in milestone.segments" :key="cohort"> {{ getCohortName(cohort) }}</span>
                </div>
              </div>
            </div>

            <div v-else>
              <span>
                All Participants
              </span>
            </div>
          </div>

          <div class="completion-window  d-flex justify-content-between" v-if="scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0">
            <p class="">Completion Window</p>
            <input type="number" placeholder="1 day" v-model="scheduler.completionWindows[milestone.milestoneDay]" v-on:blur="setCompletionWindows(milestone, scheduler.completionWindows[milestone.milestoneDay])" />
          </div>
        </div>
        <div class="" v-if="options.validateFor !== 'telehealth' && options.validateFor !== 'notification'">
          <label class="fw-normal">
            <input type="checkbox" name="allowMultipleTimes" v-model="scheduler.allowMultipleTimes" class="checkbox_position" @change="updateShowDailySummary()" />
            <span class="">
              Allow participants to repeat
              <span v-if="options.validateFor === 'survey'">survey</span>
              <span v-else>activity</span> each time it is present</span
            >
          </label>
          <div>
            <label class="fw-normal">
              <input type="checkbox" name="isActivityOptional" v-model="scheduler.isActivityOptional" class="checkbox_position" />
              <span> Activity is optional and will be excluded from the compliance report</span>
            </label>
          </div>
          <label class="fw-normal" :class="{ 'opacity-change': !scheduler.allowMultipleTimes }">
            <input type="checkbox" name="showDailySummary" v-model="scheduler.showDailySummary" class="checkbox_position" :disabled="!scheduler.allowMultipleTimes" />
            <span> Show participants a summary of their daily activity completion at the start of the activity. Available only for repeatable tasks.</span>
          </label>
          <div class="view-screen" :class="{ 'opacity-change': !scheduler.allowMultipleTimes }">
            <span v-if="scheduler.allowMultipleTimes" data-toggle="modal" data-target="#screen-modal" class="cursor_pointer">View Daily Activity Completion Screen</span>
            <span v-else>View Daily Activity Completion Screen</span>
          </div>
          <div id="screen-modal" class="modal fade modal-position" role="dialog">
            <div class="modal-dialog">
              <!-- Modal content-->
              <div class="modal-content"><img alt="repeatable-activity-example" src="static/img/repeatable-activity-example.png" /></div>
            </div>
          </div>
        </div>
        <div class="row" v-if="options.validateFor !== 'notification'">
          <div class="col-sm-8 p-0" v-if="options.validateFor === 'telehealth'">
            <div class="pt-40">
              <div class="scheduler-heading">
                How far in advance can a participant schedule their Telehealth visit?
                <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                  <i class="fa fa-info-circle p-1"></i>
                </a>
              </div>
              <input type="number" min="1" max="99" class="form-control completion_window_days" placeholder="Enter" v-model="scheduler.advanceScheduleDays" v-on:blur="calculateReminders(scheduler.completionWindow, scheduler.advanceScheduleDays)" /> days
            </div>
          </div>
        </div>
        <!-- Dynamic scheduling section starts -->

        <dynamic-scheduling-section v-if="surveyDetails && options && options.isDynamicSchedulingAvailable" :activityMode="options.activityMode" :studyData="studyDataForDynamicScheduling" :taskDetails="surveyDetails" :schedulerDetails="surveyDetails.scheduler" />

        <!-- Dynamic scheduling section ends -->
        <div v-if="options.validateFor !== 'notification'">
          <div class="scheduler-heading mt-30">Participant notifications</div>
          <div>
            <div class="survey_notification_block" v-for="(reminder, index) in reminderList" :key="index">
              <div class="row pt-5 fs-12 color_959fa4" :id="`survey-notification-content-${index}`">
                <div class="col-md-2 pl-0">
                  <div>Select day</div>
                </div>
                <div class="col-md-6 pl-0">
                  <div>Enter message</div>
                </div>
                <div class="col-md-3 pl-0">
                  <div>Select time of day</div>
                </div>
                <div class="col-md-2 pl-0 color_red pt-5"></div>
              </div>
              <div class="row">
                <div class="col-md-2 pl-0">
                  <div class="form-group mb-0">
                    <select name="day" class="form-control input-md text-color display-day input-color" v-model="reminder.day" :disabled="!isMilestoneNotification">
                      <option :value="-(remindersListTeleHealth.length - typeIndex)" v-for="(type, typeIndex) in remindersListTeleHealth" :key="typeIndex">-{{ remindersListTeleHealth.length - typeIndex }} days</option>
                      <option value="default" disabled>-select day-</option>
                      <option value="0">Day of</option>
                      <option :value="typeIndex + 1" v-for="(type, typeIndex) in remindersList" :key="typeIndex">+{{ typeIndex + 1 }} days</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6 pl-0">
                  <input type="text" class="form-control input-color" v-model="reminder.message" :disabled="!isMilestoneNotification" />
                </div>
                <div class="col-md-2 pl-0 scheduler">
                  <vue-timepicker format="hh:mm A" :minute-interval="10" value="reminder.time" v-model="reminder.time" :class="{ 'disabled-bg': !isMilestoneNotification }" :disabled="!isMilestoneNotification" required></vue-timepicker>
                  <span v-show="errors.has('reminderTime')" class="error-style">Select notification time.</span>
                </div>
                <div class="col-md-2 pl-0 color_red pt-5 cursor_pointer" v-on:click="removeReminder(index)">Remove</div>
                <div class="row w100">
                  <div class="col-md-12 pl-0">
                    <div class="sub-heading-survey-notification">
                      Notification types
                    </div>
                    <div>
                      <div class="pull-left pl-0">
                        <div class="pl-0 pull-left mr-15 custom-noti-lab">App Notification</div>
                        <div class="toggle-indicator pull-left mr-5">Off</div>
                        <label class="switch opacity-change pull-left">
                          <input type="checkbox" checked disabled="disabled" />
                          <div class="slider round"></div>
                        </label>
                        <div class="toggle-indicator pull-left ml-5">On</div>
                      </div>
                      <div class="pull-left pl-0 ml-40 email-tog">
                        <div class="pl-0 pull-left mr-15 custom-noti-lab">Email</div>
                        <div class="toggle-indicator pull-left mr-5">Off</div>
                        <label class="switch pull-left">
                          <input type="checkbox" :disabled="!isMobile" v-model="reminder.emailToggle" />
                          <div class="slider round"></div>
                        </label>
                        <div class="toggle-indicator pull-left ml-5">On</div>
                      </div>
                      <div class="pull-left pl-0 ml-40" v-if="phoneNumberEnable">
                        <div class="pl-0 pull-left mr-15 custom-noti-lab">SMS Text</div>
                        <div class="toggle-indicator pull-left mr-5">Off</div>
                        <label class="switch pull-left">
                          <input type="checkbox" :disabled="!isMobile" v-model="reminder.smsToggle" />
                          <div class="slider round"></div>
                        </label>
                        <div class="toggle-indicator pull-left ml-5">On</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
          <button type="button" class="btn add_a_notification_btn mb-40" v-on:click="addReminder()">Add a reminder</button>
        </div>
      </div>
      <div v-if="!studyData.milestones || studyData.milestones.length == 0">
        <button type="button" class="btn btn-md btn-block create_milestone_btn br-25" v-on:click="updateMilestones()">Create milestones</button>
      </div>
    </div>
    <div class="pt-40" v-if="scheduler.type === 'custom'">
      <div v-if="studyData && studyData.isSegmentSupported">
        <div class="pb-5 scheduler-heading">Which cohort(s) would you like to schedule to ?</div>
        <div class="milestone_card" :class="{ selected_milestone: segmentId == null }" v-on:click="selectUnselectSegments(null)">
          <span>
            All Participants
          </span>
        </div>
        <div :class="{ selected_milestone: segmentId && cohort.id === segmentId }" class="milestone_card" v-for="cohort in studyData.segments" :key="cohort.id" v-on:click="selectUnselectSegments(cohort.id)">
          <p class="m-0 pt-5">{{ cohort.name }}</p>
        </div>
      </div>
      <div class="pb-5 scheduler-heading">What frequency will your partcipants take this survey?</div>
      <div :class="{ selected_milestone: scheduler.frequency && scheduler.frequency.type && f.type === scheduler.frequency.type, disabled_frequency: f.disabled }" class="milestone_card" :key="index" v-for="(f, index) in frequencies" v-on:click="selectUnselectFrequency(f)">
        <p class="m-0 pt-5">{{ f.title }}</p>
        <i v-if="scheduler.frequency && scheduler.frequency.type && f.type === scheduler.frequency.type" class="fa fa-info-circle p-1" aria-hidden="true"></i>
      </div>
      <div class="" v-if="options.validateFor !== 'telehealth' && options.validateFor !== 'notification'">
        <label class="fw-normal">
          <input type="checkbox" name="allowMultipleTimes" v-model="scheduler.allowMultipleTimes" class="checkbox_position" @change="updateShowDailySummary()" />
          <span class=""> Allow participants to repeat survey each time it is present</span>
        </label>
        <div>
          <label class="fw-normal">
            <input type="checkbox" name="isActivityOptional" v-model="scheduler.isActivityOptional" class="checkbox_position" />
            <span> Activity is optional and will be excluded from the compliance report</span>
          </label>
        </div>
        <label class="fw-normal" :class="{ 'opacity-change': !scheduler.allowMultipleTimes }">
          <input type="checkbox" name="showDailySummary" v-model="scheduler.showDailySummary" class="checkbox_position" :disabled="!scheduler.allowMultipleTimes" />
          <span> Show participants a summary of their daily activity completion at the start of the activity. Available only for repeatable tasks.</span>
        </label>
        <div class="view-screen" :class="{ 'opacity-change': !scheduler.allowMultipleTimes }">
          <span v-if="scheduler.allowMultipleTimes" data-toggle="modal" data-target="#screen-modal" class="cursor_pointer">View Daily Activity Completion Screen</span>
          <span v-else>View Daily Activity Completion Screen</span>
        </div>
      </div>
      <div id="screen-modal" class="modal fade modal-position" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content"><img alt="repeatable-activity-example" src="static/img/repeatable-activity-example.png" /></div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 p-0" v-if="options.validateFor !== 'notification'">
          <div class="pt-40">
            <div class="scheduler-heading">
              What is the completion window?
              <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                <i class="fa fa-info-circle p-1"></i>
              </a>
            </div>
            <input type="number" min="1" class="form-control completion_window_days input-color" placeholder="Enter" v-model="scheduler.completionWindow" v-on:change="calculateReminders(scheduler.completionWindow)" /> days
          </div>
        </div>
        <div class="col-sm-8 p-0" v-if="options.validateFor === 'telehealth'">
          <div class="pt-40">
            <div class="scheduler-heading">
              How far in advance can a participant schedule their Telehealth visit?
              <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                <i class="fa fa-info-circle p-1"></i>
              </a>
            </div>
            <input type="number" min="1" max="99" class="form-control completion_window_days" placeholder="Enter" v-model="scheduler.advanceScheduleDays" v-on:blur="calculateReminders(scheduler.completionWindow, scheduler.advanceScheduleDays)" /> days
          </div>
        </div>
      </div>
      <div class="pt-40">
        <div class="scheduler-heading">
          Select time period this survey should appear
          <span class="study_duration">Study ends on day {{ studyDuration }}</span>
        </div>
        <div class="pb-15" v-for="(item, index) in scheduler.duration" :key="index">
          <div class="row fs-12 color_959fa4">
            <div class="col-md-2 pl-0">Start</div>
            <div class="col-md-6 pl-0">End</div>
          </div>
          <div class="row">
            <div class="col-md-1 pl-0 pr-0">
              <span class="day_label">Day</span>
            </div>
            <div class="col-md-1 pl-0">
              <input type="number" v-validate="'required|min_value:1'" name="startDay" class="form-control" v-model="item.startDay" @input="isNumber()" />
            </div>
            <div class="col-md-1 pl-0 pr-0">
              <span class="day_label">Day</span>
            </div>
            <div class="col-md-1 pl-0">
              <input type="number" class="form-control" v-validate="'required|min_value:1'" name="endDay" v-model="item.endDay" :disabled="scheduler.allowUntillDuration && index + 1 === scheduler.duration.length" @input="isNumber()" />
            </div>
            <div class="col-md-2 pl-0 color_blue cursor_pointer pt-5" v-on:click="addAnotherDuration(index)" v-if="scheduler.duration.length === index + 1 && !scheduler.allowUntillDuration">Add another time period</div>
            <div class="col-md-2 pl-0 color_red cursor_pointer pt-5" v-on:click="removeDuration(index)" v-if="scheduler.duration.length !== index + 1">Remove</div>
          </div>
        </div>
        <div class="pt-10">
          <label class="fw-normal">
            <input type="checkbox" class="checkbox_position" name="allowUntillDuration" v-model="scheduler.allowUntillDuration" v-on:change="allowUntilDurationChanges(scheduler.allowUntillDuration)" />
            <span class=""> Available until the end of participant's study duration</span>
          </label>
        </div>
      </div>

      <!-- Dynamic scheduling section starts -->

      <dynamic-scheduling-section v-if="surveyDetails && options && options.isDynamicSchedulingAvailable" :activityMode="options.activityMode" :studyData="studyDataForDynamicScheduling" :taskDetails="surveyDetails" :schedulerDetails="surveyDetails.scheduler" />

      <!-- Dynamic scheduling section ends -->

      <div v-if="options.validateFor !== 'notification'">
        <div class="scheduler-heading mt-30" v-if="options.validateFor !== 'telehealth'">Participant notifications</div>
        <div v-for="(reminder, index) in reminderList" :key="index">
          <div class="survey_notification_block surv_noti" :id="`survey-notification-content-${index}`">
            <div class="row pt-5 fs-12 color_959fa4">
              <div class="col-md-2 pl-0">
                <div>Select day</div>
              </div>
              <div class="col-md-6 pl-0">
                <div>Enter message</div>
              </div>
              <div class="col-md-3 pl-0">
                <div>Select time of day</div>
              </div>
              <div class="col-md-1 pl-0 color_red pt-5"></div>
            </div>
            <div class="row">
              <div class="col-md-2 pl-0">
                <div class="form-group">
                  <select name="day" class="form-control input-md text-color display-day  input-color" v-model="reminder.day" :disabled="!scheduler.completionWindow">
                    <option :value="-(remindersListTeleHealth.length - typeIndex)" :key="typeIndex" v-for="(type, typeIndex) in remindersListTeleHealth">-{{ remindersListTeleHealth.length - typeIndex }} days</option>
                    <option value="default" disabled>-select day-</option>
                    <option value="0">Day of</option>
                    <option :value="typeIndex + 1" v-for="(type, typeIndex) in remindersList" :key="typeIndex">+{{ typeIndex + 1 }} days</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 pl-0">
                <input type="text" class="form-control input-color" v-model="reminder.message" :disabled="!scheduler.completionWindow" />
              </div>
              <div class="col-md-2 pl-0 scheduler">
                <vue-timepicker format="hh:mm A" :minute-interval="10" v-model="reminder.time" :disabled="!scheduler.completionWindow" required></vue-timepicker>
                <span v-show="errors.has('reminderTime')" class="error-style">Select notification time.</span>
              </div>
              <div class="col-md-2 pl-0 color_red pt-5 cursor_pointer" v-on:click="removeReminder(index)">Remove</div>

              <div class="row w100">
                <div class="col-md-12 pl-0">
                  <div class="sub-heading-survey-notification mt-0 mb-10">
                    Notification types
                  </div>
                  <div>
                    <div class="pull-left pl-0">
                      <div class="pl-0 pull-left mr-15 custom-noti-lab">App Notification</div>
                      <div class="toggle-indicator pull-left mr-5 opacity-change">Off</div>
                      <label class="switch opacity-change pull-left">
                        <input type="checkbox" checked disabled="disabled" />
                        <div class="slider round"></div>
                      </label>
                      <div class="toggle-indicator pull-left ml-5 opacity-change">On</div>
                    </div>
                    <div class="pull-left pl-0 ml-40 email-tog">
                      <div class="pl-0 pull-left mr-15 custom-noti-lab">Email</div>
                      <div class="toggle-indicator pull-left mr-5">Off</div>
                      <label class="switch pull-left">
                        <input type="checkbox" :disabled="!isMobile" v-model="reminder.emailToggle" />
                        <div class="slider round"></div>
                      </label>
                      <div class="toggle-indicator pull-left ml-5">On</div>
                    </div>
                    <div class="pull-left pl-0 ml-40" v-if="phoneNumberEnable">
                      <div class="pl-0 pull-left mr-15 custom-noti-lab">SMS Text</div>
                      <div class="toggle-indicator pull-left mr-5">Off</div>
                      <label class="switch pull-left">
                        <input type="checkbox" :disabled="!isMobile" v-model="reminder.smsToggle" />
                        <div class="slider round"></div>
                      </label>
                      <div class="toggle-indicator pull-left ml-5">On</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>
        <button type="button" class="btn add_a_notification_btn mb-40" v-on:click="addReminder()">Add a reminder</button>
      </div>
    </div>
    <div id="completionModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div>
            <div class="row text-right">
              <a class="cancelImage cursor_pointer" data-dismiss="modal">
                <i class="fa fa-times" aria-hidden="true"></i>
              </a>
            </div>
            <div class="example">
              <p class="example-header">
                When a task is assigned to the participant, you have the opportunity to set the window of completion for the task before it expires.
              </p>
              <div class="bg-milestone pb-40">
                <p class="example-content text-center">
                  Example: A survey is assigned to a participant at study week 2, which for this participant happens to be a Wednesday, and a 3 day completion window has been set. The survey will be pushed to the participant on Wednesday and will be available through Friday. On Saturday morning, the survey will be removed from participant’s task list and will be reported as a missed task.
                </p>
                <div class="row milestone">
                  <div class="col-lg-2 ml-0 pl-0 mr-0 pr-0" v-for="(milestone, index) in exampleMileStone" :key="index">
                    <div class="text-center">{{ milestone.day }}</div>
                    <div class="milestone_box" :class="{ 'white-bg': milestone.day === 'Sat' }">
                      <div class="circle" v-if="milestone.class" :class="{ 'bg-green': milestone.day === 'Wed', 'bg-red': milestone.day === 'Sat' }"></div>
                    </div>
                    <div class="text-center">{{ milestone.date }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
import _ from "lodash";
import VueTimepicker from "vue2-timepicker";
import { mapGetters } from "vuex";
import { TRIGGER_NAME, ACTION_NAME, SCHEDULINGS_NAME } from "@/constants/dynamicSchedulingConstants";
import DynamicSchedulingSection from "../common/dynamic-scheduling-components-collection/dynamic-scheduling-section";
import moment from "moment";

const MODE = { schedule: "schedule", both: "both", onDemand: "onDemand", dynamicOnly: "dynamicOnly" };

export default {
  name: "scheduler",
  data() {
    return {
      studyId: null,
      phoneNumberEnable: false,
      surveyId: null,
      studyData: {},
      surveyData: {},
      finalMilestoneCount: [],
      studyDuration: null,
      addedCompletionWindows: [],
      milestoneAndCompletionWindow: [],
      taskId: null,
      milestones: [],
      frequencies: [
        { type: "daily", title: "Daily", days: 1, disabled: false },
        { type: "weekly", title: "Weekly", days: 7, disabled: false },
        { type: "biweekly", title: "Every 2 Weeks", days: 14, disabled: false },
        { type: "monthly", title: "Monthly", days: 30, disabled: false },
        { type: "biannually", title: "Bi-annually", days: 182, disabled: false },
        { type: "annually", title: "Annually", days: 365, disabled: false }
      ],
      scheduler: {
        type: "milestone",
        milestones: [],
        frequency: { type: null, title: null, days: null },
        startDay: null,
        endDay: null,
        completionWindows: {},
        reminders: [],
        notificaitons: [],
        allowMultipleTimes: false,
        allowUntillDuration: false,
        showDailySummary: false,
        duration: [{ startDay: null, endDay: null }],
        activitySchedulingMode: "schedule",
        isActivityOptional: false
      },
      remindersList: [],
      remindersListTeleHealth: [],
      reminderList: [
        {
          day: "default",
          message: null,
          time: {
            hh: "",
            mm: "",
            A: ""
          },
          smsToggle: false,
          emailToggle: false
        }
      ],
      exampleMileStone: [
        { date: "Day1", day: "Wed", class: "bg-green" },
        { date: "Day2", day: "Thur", class: "" },
        { date: "Day3", day: "Fri", class: "" },
        { date: "+2", day: "Sat", class: "bg-red" }
      ],
      time: {
        hh: "",
        mm: "",
        A: ""
      },
      savedScheduler: null,
      defaultSchedulerObj: {
        type: "milestone",
        milestones: [],
        frequency: { type: null, title: null, days: null },
        startDay: null,
        endDay: null,
        completionWindow: null,
        reminders: [
          {
            day: "default",
            message: null,
            time: {
              hh: "",
              mm: "",
              A: ""
            }
          }
        ],
        allowMultipleTimes: false,
        allowUntillDuration: false,
        showDailySummary: false,
        duration: [{ startDay: null, endDay: null }],
        activitySchedulingMode: "schedule"
      },
      activityDataIsLoaded: false,
      dynamicScheduleUpdated: false,
      isMilestoneNotification: false,
      segmentId: null,
      getApiCohortSchedular: null,
      getApiSchedular: null,
      surveyDetails: null,
      studyDataForDynamicScheduling: null,
      screenCountCheck: [],
      checkCount: 0,
      dynamicScheduleActivityAssociation: []
    };
  },
  components: {
    VueTimepicker,
    DynamicSchedulingSection
  },
  props: ["options"],
  computed: {
    ...mapGetters(["getDynamicActivitySchedules", "getConstantDynamicActivitySchedulesData"]),
    schedulerObjChanged() {
      return this.$store.getters.getSchedulerObjData;
    },
    isMobile() {
      if (this.studyData) {
        return !!(this.studyData.android || this.studyData.ios);
      }
      return false;
    },
    regularMilestones() {
      if (this.studyData.milestonesList) {
        if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
          let filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType != "screening");
          filtered.forEach(mile => {
            mile.milestoneDay -= this.studyData.screeningDuration;
          });
          filtered = _.sortBy(filtered, "milestoneDay");
          return filtered;
        } else {
          this.studyData.milestonesList = _.sortBy(this.studyData.milestonesList, "milestoneDay");
          return this.studyData.milestonesList;
        }
      }
      return [];
    },
    screeningMilestones() {
      if (this.studyData.milestonesList) {
        const filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType == "screening");
        filtered.forEach(mile => {
          mile.milestoneDay -= this.studyData.screeningDuration;
        });
        return _.sortBy(filtered, "milestoneDay");
      }
      return [];
    },
    currentMilestones() {
      return this.studyData.milestonesList.map(it => it.milestoneDay + this.studyData.screeningDuration);
    }
  },
  mounted() {
    this.studyId = this.$route.params.studyId;
    this.surveyId = this.$route.params.surveyId;
    this.getStudyDetails();
    this.getRegistration();
    //this.milestoneNotificationRemainder();
  },
  watch: {
    schedulerObjChanged: {
      handler(val) {
        if (val.validateFor) {
          if (val.autoSave) {
            this.checkValidation(this.scheduler, val.autoSave);
          } else {
            this.checkValidation(this.scheduler);
          }
        }
      }
    },
    "options.activityMode": {
      handler(val) {
        if (val !== null) {
          if (this.activityDataIsLoaded) {
            this.getDefaultValue(this.scheduler, this.surveyData, this);
          }
        }
      }
    }
  },
  methods: {
    cleanupOldMilestoneDataFromScheduler(scheduler, milestones) {
      let studyMilestones = milestones || this.currentMilestones;
      if (scheduler && scheduler.milestones) {
        scheduler.milestones = scheduler.milestones.filter(it => studyMilestones.includes(it));
      }
      if (scheduler && scheduler.completionWindows) {
        scheduler.completionWindows = Object.entries(scheduler.completionWindows)
          .filter(([k, v]) => studyMilestones.includes(+k))
          .reduce((acc, [k, v]) => {
            acc[k] = v;
            return acc;
          }, {});
      }
      return scheduler;
    },
    selectUnselectSegments(cohortId) {
      this.segmentId = cohortId;
      let index = -1;
      if (this.surveyData.segmentSchedules) {
        index = this.surveyData.segmentSchedules.findIndex(data => {
          return data.segmentId == cohortId;
        });
      }
      //when you click on cohort from all participants
      if (index > -1) {
        this.scheduler = _.cloneDeep(this.surveyDetails.segmentSchedules[index]);
        this.reminderList = this.scheduler.reminders;
        if (this.reminderList && this.reminderList.length > 0) {
          this.convertReminderTimeStringToObj();
        } else {
          this.reminderList = [];
          this.reminderList[0] = this.defaultReminder();
        }

        if (this.studyData.screeningMilestoneAllowed) {
          if (this.scheduler.duration && this.scheduler.duration.length > 0) {
            this.scheduler = this.filterSchedulerDurationForScreening(this.scheduler);
          }
        }

        if (this.reminderList && this.reminderList.length > 0) {
          this.calculateReminders(this.scheduler.completionWindow, null);
        }
      }
      //When you click on all participants from cohorts
      else if (this.surveyData.scheduler && !cohortId) {
        this.scheduler = _.cloneDeep(this.surveyDetails.scheduler);
        this.reminderList = this.scheduler.reminders;
        if (this.reminderList && this.reminderList.length > 0) {
          this.convertReminderTimeStringToObj();
        } else {
          this.reminderList = [];
          this.reminderList[0] = this.defaultReminder();
        }

        if (this.studyData.screeningMilestoneAllowed) {
          if (this.scheduler.duration && this.scheduler.duration.length > 0) {
            this.scheduler = this.filterSchedulerDurationForScreening(this.scheduler);
          }
        }
      } else {
        //clicking from all participants to any cohort which does not exist
        this.scheduler.completionWindow = null;
        this.scheduler.duration = [{ startDay: null, endDay: null }];
        this.reminderList = [];
        this.reminderList[0] = this.defaultReminder();
      }
    },
    filterSchedulerDurationForScreening(scheduler) {
      scheduler.duration.forEach((duration, i) => {
        if (duration.startDay != null) {
          Object.keys(duration).forEach(key => {
            duration[key] -= this.studyData.screeningDuration;
          });
        }
      });
      return scheduler;
    },
    getCohortName(segmentId) {
      let selectedCohorts = this.studyData.segments.find(field => {
        return field.id == segmentId;
      });
      return selectedCohorts ? selectedCohorts.name : "All Participants";
    },

    setCompletionWindows(milestone, completionWindow) {
      milestone.completionWindow = Number(completionWindow);
      if (this.options.validateFor !== "notification") {
        this.milestoneNotificationRemainder();
      }
    },
    goBack() {
      window.history.back();
    },
    defaultReminder() {
      return {
        day: "default",
        message: null,
        time: {
          hh: "",
          mm: "",
          A: ""
        },
        smsToggle: false,
        emailToggle: false
      };
    },
    changeType(type) {
      this.scheduler.type = type;
      this.reminderList[0] = this.defaultReminder();
      if (this.scheduler.type === "milestone") {
        if (this.options.validateFor !== "notification") {
          this.milestoneNotificationRemainder();
        }
      } else {
        this.calculateReminders(this.scheduler.completionWindow, null);
      }
    },
    getRegistration() {
      this.$api.getRegistrationFact(this.studyId).then(response => {
        if (response.body.participantRegistrationConfigDetails) {
          const isPhoneEnable = response.body.participantRegistrationConfigDetails.filter(data => data.key === "phoneNumber" && data.isVisible === true);
          if (isPhoneEnable.length > 0) {
            this.phoneNumberEnable = true;
          }
        }
      });
    },
    getSchedulerDetails() {
      switch (this.options.validateFor) {
        case "edro":
          // use this.options.edro.scheduler
          let maxedroCompletionWindow = 0;
          let useScheduler = this.options && this.options.scheduler ? this.options.scheduler : this.defaultSchedulerObj;
          //in edit checking the milestone completion windows exist or not. if windows exist showing the notification
          if (useScheduler.completionWindows && useScheduler.completionWindows != null && Object.keys(useScheduler.completionWindows).length !== 0) {
            this.isMilestoneNotification = true;
            let arr = Object.values(useScheduler.completionWindows);
            maxedroCompletionWindow = Math.max(...arr);
          }
          this.activityDataIsLoaded = true;
          this.surveyData.scheduler = this.cleanupOldMilestoneDataFromScheduler(
            _.cloneDeep(useScheduler),
            [...this.screeningMilestones, ...this.regularMilestones].map(it => it.milestoneDay)
          );
          this.getDefaultValue(_.cloneDeep(useScheduler), null, this);
          //in edit time calling caluculateReminder with highest completion window value
          if (maxedroCompletionWindow > 0) {
            this.calculateReminders(maxedroCompletionWindow, null);
          }
          break;
        case "notification":
          if (this.options.scheduler) {
            this.scheduler = this.cleanupOldMilestoneDataFromScheduler(
              this.options.scheduler,
              [...this.screeningMilestones, ...this.regularMilestones].map(it => it.milestoneDay)
            );
          }
          //for old custome notifications
          if (!this.scheduler.completionWindows) {
            this.scheduler.completionWindows = {};
          }
          break;
        case "telehealth":
          this.getTruClinicDetails();
          break;
        default:
          this.getSurveyDetails();
      }
    },
    getTruClinicDetails() {
      this.$api.getTruClinicDetailsFact(this.studyId).then(
        response => {
          if (response.body.taskId) {
            response.body = this.cleanupOldMilestoneDataFromScheduler(response.body);
            this.scheduler = response.body;
            if (!this.scheduler.duration || this.scheduler.duration.length === 0) {
              this.scheduler.duration = [{ startDay: null, endDay: null }];
            }
            this.taskId = response.body.taskId;
            this.reminderList = this.scheduler.reminders && this.scheduler.reminders.length > 0 ? this.scheduler.reminders : this.reminderList;
            this.reminderList.forEach(val => {
              if (this.isMobile == false) {
                val.smsToggle = false;
                val.emailToggle = false;
              }
              if (val && val.time && typeof val.time === "string") {
                const [hm, a] = val.time.split(" ");
                const [hh, mm] = hm.split(":");
                val.time = {
                  hh: "",
                  mm: "",
                  A: ""
                };
                val.time.hh = hh;
                val.time.mm = mm;
                val.time.A = a;
              }
            });
            this.calculateReminders(this.scheduler.completionWindow, this.scheduler.advanceScheduleDays);
          }
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    selectUnselectMileStone(milestone) {
      if (!this.scheduler.milestones) {
        this.scheduler.milestones = [];
      }
      if (!this.scheduler.completionWindows) {
        this.scheduler.completionWindows = {};
      }
      if (this.scheduler && this.scheduler.milestones && this.scheduler.milestones.indexOf(milestone) < 0) {
        this.scheduler.milestones.push(milestone);
        if (this.options.validateFor !== "notification") {
          this.milestoneNotificationRemainder();
        }
      } else {
        this.scheduler.milestones.splice(this.scheduler.milestones.indexOf(milestone), 1);
        delete this.scheduler.completionWindows[milestone];
        if (this.options.validateFor !== "notification") {
          this.milestoneNotificationRemainder();
        }
      }
      this.$forceUpdate();
    },
    calculateReminders(completionWindowOld, advanceScheduleDaysOld) {
      let completionWindow = completionWindowOld;
      let advanceScheduleDays = advanceScheduleDaysOld;
      completionWindow = Number(completionWindow) === 0 ? 1 : completionWindow;
      if (completionWindow) {
        this.remindersList.length = Number(completionWindow) - 1;
      }
      if (advanceScheduleDays && parseInt(advanceScheduleDays, 10) > 99) {
        toastr.error("Advanced days cannot be more than 99");
      } else {
        advanceScheduleDays = Number(advanceScheduleDays) ? advanceScheduleDays : 0;
        if (advanceScheduleDays) {
          this.remindersListTeleHealth.length = Number(advanceScheduleDays);
        }
      }
      this.$forceUpdate();
    },
    updateMilestones() {
      window.localStorage.setItem("designIndex", 14);
      this.$router.push({ name: "study-design", params: { studyId: this.studyId } });
    },
    selectUnselectFrequency(frequency) {
      this.scheduler.frequency = frequency;
      this.$forceUpdate();
    },
    addReminder() {
      this.reminderList.push({
        day: "default",
        message: null,
        time: {
          hh: "",
          mm: "",
          A: ""
        },
        smsToggle: false,
        emailToggle: false
      });
      this.$nextTick(() => {
        this.smoothLandingOnScreen();
      });
    },
    smoothLandingOnScreen() {
      let index = this.reminderList.length - 1;
      this.screenId = "survey-notification-content-" + index;
      let element = document.getElementById(this.screenId);
      element.scrollIntoView({
        block: "center",
        inline: "center",
        behavior: "smooth"
      });
    },
    removeReminder(index) {
      this.reminderList.splice(index, 1);
      if (this.reminderList.length === 0) {
        this.addReminder();
      }
    },
    skipForNow() {
      this.$router.push({
        name: "survey-as-template",
        params: { studyId: this.studyId, surveyId: this.surveyId }
      });
    },
    allowUntilDurationChanges(allowUntillDuration) {
      if (allowUntillDuration) {
        this.scheduler.duration[this.scheduler.duration.length - 1].endDay = null;
      }
    },
    addAnotherDuration() {
      this.scheduler.duration.push({ startDay: null, endDay: null });
      this.$forceUpdate();
    },
    removeDuration(index) {
      this.scheduler.duration.splice(index, 1);
      this.$forceUpdate();
    },
    getSurveyDetails() {
      const self = this;
      this.$api.getSurveyDetailsFact(this.studyId, this.surveyId).then(
        response => {
          response.body.scheduler = this.cleanupOldMilestoneDataFromScheduler(response.body.scheduler);
          self.surveyData = response.body;

          if (response && response.body && response.body.segmentSchedules && response.body.segmentSchedules.length > 0) {
            this.findLastSavedCohortSchedule(response.body.segmentSchedules);
            const segmentData = response.body.segmentSchedules.filter(seg => seg.segmentId == this.segmentId);
            response.body.scheduler = this.cleanupOldMilestoneDataFromScheduler(segmentData[0]);
            self.surveyData = response.body;
          }
          this.surveyDetails = _.cloneDeep(self.surveyData); /* To pass untouched 'survey-details' data to 'Dynamic Activity Scheduling' components */
          this.getActivityAssociationInDynamicSchedules();
          // If we have scheduled this activity earlier then get saved scheduler, otherwise let it be default
          let useScheduler = self.surveyData.scheduler ? self.surveyData.scheduler : self.defaultSchedulerObj;

          self.getDefaultValue(useScheduler, self.surveyData, self);
          self.activityDataIsLoaded = true;
          self.savedScheduler = _.cloneDeep(useScheduler);
          self.scheduler = response.body.scheduler ? response.body.scheduler : self.scheduler;

          if (!self.scheduler.duration || self.scheduler.duration.length === 0) {
            self.scheduler.duration = [{ startDay: null, endDay: null }];
          }

          self.$store.dispatch("setSurveyDetailsAction", response.body);

          if (response.body.scheduler) {
            this.getApiSchedular = _.cloneDeep(response.body.scheduler);
            self.scheduler = response.body.scheduler;
          }
          if (response.body.segmentSchedules) {
            this.getApiCohortSchedular = _.cloneDeep(response.body.segmentSchedules);

            if (response.body.segmentSchedules.length > 0) {
              this.findLastSavedCohortSchedule(response.body.segmentSchedules);
              let foundSegment = response.body.segmentSchedules.filter(seg => seg.segmentId == this.segmentId);
              if (foundSegment && foundSegment.length > 0) {
                self.scheduler = foundSegment[0];
              } else {
                self.scheduler = self.surveyData.scheduler;
              }
            } else {
              self.scheduler = self.surveyData.scheduler;
              this.segmentId = null;
            }
          }

          if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
            if (self.scheduler.milestones && self.scheduler.milestones.length > 0) {
              self.scheduler.milestones = this.filterSchedulerMilestonesForDisplay(self.scheduler.milestones);
              self.scheduler.completionWindows = this.filteredCompletionWindowsForDisplay(self.scheduler.completionWindows);
            }
            if (self.scheduler.duration && self.scheduler.duration.length > 0) {
              self.scheduler = this.filterSchedulerDurationForScreening(self.scheduler);
            }
          }

          if (this.segmentId) {
            let segment = response.body.segmentSchedules.filter(seg => seg.segmentId == this.segmentId);
            self.reminderList = segment[0].reminders && segment[0].reminders.length > 0 ? segment[0].reminders : self.reminderList;
          } else {
            if (self.scheduler) {
              self.reminderList = self.scheduler.reminders && self.scheduler.reminders.length > 0 ? self.scheduler.reminders : self.reminderList;
            }
          }

          //in edit checking the milestone completion windows exist or not
          if (self.scheduler.completionWindows && self.scheduler.completionWindows != null && Object.keys(self.scheduler.completionWindows).length !== 0) {
            this.isMilestoneNotification = true;
            self.calculateReminders(self.scheduler.completionWindow, null);
          }
          this.convertReminderTimeStringToObj();
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the survey details");
        }
      );
    },
    findLastSavedCohortSchedule(segments) {
      //Handle the situation where all the lastModifiedDate is null
      // Handle the situation where some of the values are null then find the earliest from the rest
      let allDates = segments.map(segment => segment.lastModifiedDate && new Date(segment.lastModifiedDate));
      if (allDates && allDates.length > 0 && allDates[0] !== undefined) {
        let earliestSegment = new Date(Math.max.apply(null, allDates));

        segments.map(segment => {
          let formatted = new Date(segment.lastModifiedDate);
          if (formatted.getTime() == earliestSegment.getTime()) {
            this.segmentId = segment.segmentId;
          }
        });

        if (this.surveyDetails && this.surveyDetails.scheduler) {
          let formattedDate = new Date(this.surveyDetails.scheduler.lastModifiedDate);
          if (formattedDate.getTime() > earliestSegment.getTime()) {
            this.segmentId = null;
          }
        }
      } else {
        this.setSegmentIdToLast();
      }
    },
    setSegmentIdToLast() {
      let lastSegmentIndex = this.surveyDetails.segmentSchedules.length - 1;
      this.scheduler = this.surveyDetails.segmentSchedules[lastSegmentIndex];
      this.segmentId = this.surveyDetails.segmentSchedules[lastSegmentIndex].segmentId;
    },
    convertReminderTimeStringToObj() {
      this.reminderList.forEach(val => {
        if (this.isMobile == false) {
          val.smsToggle = false;
          val.emailToggle = false;
        }
        if (typeof val.time == "string") {
          const [hm, a] = val.time.split(" ");
          const [hh, mm] = hm.split(":");
          val.time = {
            hh: "",
            mm: "",
            A: ""
          };
          val.time.hh = hh;
          val.time.mm = mm;
          val.time.A = a;
        }
      });
    },
    getDefaultValue(scheduler, data, _this) {
      let selectedMode = _this.options.activityMode;
      if (selectedMode) {
        if (selectedMode === MODE.schedule || selectedMode === MODE.both) {
          // when either 'Scheduled' or 'Scheduled & On-demand' type button is selected
          let savedMode;
          if (_this.surveyData.scheduler) {
            // if activity has saved scheduler | case: edit
            savedMode = _this.surveyData.scheduler.activitySchedulingMode;
          } else {
            // if activity has no saved scheduler | case: add/edit
            savedMode = scheduler.activitySchedulingMode;
          }
          if (selectedMode !== savedMode) {
            _this.initialize("empty", _this.defaultSchedulerObj, data);
          } else {
            if (_this.surveyData.scheduler) {
              // if activity has saved scheduler
              _this.initialize("fill", _this.surveyData.scheduler, data);
            } else {
              // if activity has no saved scheduler
              _this.initialize("empty", _this.defaultSchedulerObj, data);
            }
          }
        } else {
          if (_this.surveyData.scheduler) {
            // if activity has saved scheduler
            _this.scheduler = { taskId: _this.surveyData.scheduler.taskId, taskType: _this.surveyData.scheduler.taskType, activitySchedulingMode: selectedMode, taskTitle: _this.surveyData.scheduler.taskTitle };
          } else {
            // if activity has no saved scheduler
            _this.scheduler = { taskId: null, taskType: null, activitySchedulingMode: selectedMode, taskTitle: null };
          }
        }
      }
    },
    initialize(type, scheduler, data) {
      let self = this;
      const isEmpty = type => {
        return type === "empty";
      };
      const isFill = type => {
        return type === "fill";
      };
      self.scheduler = scheduler && isFill(type) ? scheduler : _.cloneDeep(self.defaultSchedulerObj);
      if (!self.scheduler.duration || self.scheduler.duration.length === 0 || isEmpty(type)) {
        self.scheduler.duration = [{ startDay: null, endDay: null }];
      }

      self.reminderList = scheduler.reminders && scheduler.reminders.length > 0 && isFill(type) ? scheduler.reminders : self.defaultSchedulerObj.reminders;

      self.reminderList.forEach(val => {
        if (val && val.time && typeof val.time === "string") {
          const [hm, a] = val.time.split(" ");
          const [hh, mm] = hm.split(":");
          val.time = {
            hh: "",
            mm: "",
            A: ""
          };
          val.time.hh = hh;
          val.time.mm = mm;
          val.time.A = a;
        }
      });
      if (isFill(type)) {
        self.calculateReminders(scheduler.completionWindow, null);
      }
      if (self.options.activityMode !== "edro") {
        self.$store.dispatch("setSurveyDetailsAction", data);
      }
    },
    getExactDayEpoch(day) {
      const newDay = new Date(day);
      return new Date(newDay.getFullYear(), newDay.getMonth(), newDay.getDate(), 0, 0, 0).getTime();
    },
    isNumber() {
      this.scheduler.duration.filter(rec => {
        if (rec.startDay) {
          if (rec.startDay % 1 !== 0 || rec.startDay < 0) {
            rec.startDay = parseInt(rec.startDay);
          }
          rec.startDay = parseInt(rec.startDay);
        }
        if (rec.endDay) {
          if (rec.endDay % 1 !== 0 || rec.endDay < 0) {
            rec.endDay = parseInt(rec.endDay);
          }
          rec.endDay = parseInt(rec.endDay);
        }
      });
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
          this.studyDataForDynamicScheduling = _.cloneDeep(response.body);
          this.getSchedulerDetails();
          const sd = new Date(this.studyData.firstPatientEnrollDate).valueOf();
          const ed = new Date(this.studyData.firstPatientLastDate).valueOf();
          this.studyDuration = parseInt((this.getExactDayEpoch(ed) - this.getExactDayEpoch(sd)) / 1000 / 86400, 10);
          _.forEach(this.frequencies, val => {
            switch (val.type) {
              case "daily":
                val.disabled = this.studyDuration < 1;
                break;
              case "weekly":
                val.disabled = this.studyDuration < 7;
                break;
              case "biweekly":
                val.disabled = this.studyDuration < 15;
                break;
              case "monthly":
                val.disabled = this.studyDuration < 30;
                break;
              case "biannually":
                val.disabled = this.studyDuration < 180;
                break;
              case "annually":
                val.disabled = this.studyDuration < 365;
                break;
              default:
                break;
            }
          });
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    findMinDiff(val) {
      let s = val;
      let m, i, j;
      // eslint-disable-next-line no-eval
      s = eval(s);
      m = Math.abs(s[(i = 0)] - s[(j = 1)]);
      for (; i < s.length; i++) {
        j = i;
        for (++j; j < s.length; ++j) {
          const newV = Math.abs(s[i] - s[j]);
          m = newV < m ? newV : m;
        }
      }
      return m;
    },
    isSorted(arr) {
      const len = arr.length - 1;
      for (let i = 0; i < len; ++i) {
        if (arr[i] > arr[i + 1]) {
          return false;
        }
      }
      return true;
    },
    validateCustomType(scheduler, properList) {
      if (scheduler.advanceScheduleDays === null || scheduler.advanceScheduleDays === undefined || scheduler.advanceScheduleDays < 0 || scheduler.advanceScheduleDays % 1 !== 0 || scheduler.advanceScheduleDays > 99) {
        toastr.error("Advance scheduling days should be between 0 and 99, and cannot have decimals");
        return false;
      }
      let minDuration = 365;
      for (let i = 0; i < properList.length / 2; i++) {
        if (properList[i + i + 2] && properList[i + i + 1] && minDuration > properList[i + i + 2] - properList[i + i + 1]) {
          minDuration = properList[i + i + 2] - properList[i + i + 1] - 1;
        }
      }
      const fcwDiff = scheduler.frequency.days - scheduler.completionWindow;
      minDuration = minDuration > fcwDiff ? fcwDiff : minDuration;
      if (scheduler.advanceScheduleDays > minDuration) {
        if (minDuration !== 0) {
          toastr.error(`Number of advanced days can be between 0 and ${minDuration}`);
        } else if (minDuration === 0) {
          toastr.error("Number of advanced days can be 0 only");
        }
      }
      return scheduler.advanceScheduleDays <= minDuration;
    },
    validateMilestoneType(possibleVal, valid, scheduler, mArr, milestones) {
      let validScheduler = valid;
      let minDiff = null;
      if (possibleVal && validScheduler && (scheduler.advanceScheduleDays === null || scheduler.advanceScheduleDays === undefined || scheduler.advanceScheduleDays < 0 || scheduler.advanceScheduleDays % 1 !== 0)) {
        validScheduler = false;
        toastr.error(scheduler.advanceScheduleDays ? "Advance days cannot have decimals" : "Please enter advance days");
      }
      if (mArr.length !== 0) {
        // when multiple milestones are selected
        const milestoneArr = _.sortBy(mArr);
        const diffArr = [];
        for (let i = 1; i < milestoneArr.length; i++) {
          diffArr[i - 1] = milestoneArr[i] - (milestoneArr[i - 1] + scheduler.completionWindow);
        }
        minDiff = _.min(diffArr);
      } else {
        // when one milestone is selected
        minDiff = milestones[0] !== 0 ? milestones[0] - 1 : 0;
      }
      if (scheduler.milestones.length === 1) {
        minDiff = scheduler.milestones[0];
      }
      if (scheduler.advanceScheduleDays > minDiff) {
        if (minDiff !== 0) {
          toastr.error(`Number of advanced days can be between 0 and ${minDiff}`);
        } else if (minDiff === 0) {
          toastr.error("Number of advanced days can be 0 only");
        }
      }
      return scheduler.advanceScheduleDays <= minDiff && validScheduler;
    },
    validateMilestones(list, duration, type) {
      let milestoneList = list;
      let filteredScheduler;
      let filteredCompletionWindow = _.cloneDeep(this.scheduler.completionWindows);

      if (filteredCompletionWindow) {
        if (type == "screening") {
          filteredScheduler = this.scheduler.milestones.filter(m => m < 0);
          Object.keys(filteredCompletionWindow).forEach(key => {
            if (key >= 0) {
              delete filteredCompletionWindow[key];
            }
          });
        } else {
          filteredScheduler = this.scheduler.milestones.filter(m => m >= 0);
          Object.keys(filteredCompletionWindow).forEach(key => {
            if (key < 0) {
              delete filteredCompletionWindow[key];
            }
          });
        }
      }

      if (filteredScheduler) {
        filteredScheduler.sort((a, b) => a - b);
        for (let i = 0; i < milestoneList.length; i++) {
          let milestoneDay = milestoneList[i].milestoneDay;
          let completionWindow = filteredCompletionWindow[milestoneDay];
          let selectedMilestoneIndex = filteredScheduler.indexOf(milestoneDay);

          let nextSelectedMilestoneDay = filteredScheduler[selectedMilestoneIndex + 1];

          completionWindow = Number(completionWindow);

          if (filteredScheduler.indexOf(milestoneDay) < 0) {
            continue;
          }
          if (!completionWindow) {
            toastr.error("Number of days for completion window is required.");
            return;
          } else if (completionWindow < 1) {
            toastr.error("Please specify completion window with value greater than 0.");
            return;
          } else if (completionWindow > duration) {
            if (type == "screening") {
              toastr.error(`Specified completion window cannot exceed ${type} duration.`);
            } else {
              toastr.error("Specified completion window cannot exceed study duration.");
            }
            return;
          } else if (!!nextSelectedMilestoneDay && milestoneDay + completionWindow > nextSelectedMilestoneDay) {
            toastr.error(`Specified completion window overlaps with another ${type} milestone.`);
            return;
          }
        }
        return true;
      }
    },
    updateDynamicSchedulePropertyValue(value) {
      this.dynamicScheduleUpdated = value;
      return this.dynamicScheduleUpdated;
    },
    checkIfDynamicScheduleChanged(constantSchedule, changedSchedule) {
      let actions = null;

      let c_actions = null;

      let conditions = null;

      let c_conditions = null;

      let scheduling = null;

      let c_scheduling = null;

      let index = 0;

      actions = constantSchedule.actions;
      c_actions = changedSchedule.actions;

      conditions = constantSchedule.conditions;
      c_conditions = changedSchedule.conditions;

      scheduling = constantSchedule.scheduling[0];
      c_scheduling = changedSchedule.scheduling[0];

      if (actions.length != c_actions.length) {
        return this.updateDynamicSchedulePropertyValue(true);
      }

      index = 0;
      for (let a of actions) {
        if (a["type"] != c_actions[index]["type"]) {
          return this.updateDynamicSchedulePropertyValue(true);
        }

        if (a["type"] == ACTION_NAME.ADD_AN_ACTIVITY) {
          if (a["tasks"] && a["tasks"][0]["taskID"] != c_actions[index]["tasks"][0]["taskID"]) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        } else if (a["type"] == ACTION_NAME.REMOVE_AN_ACTIVITY) {
          if (a["tasks"] && a["tasks"][0]["taskID"] != c_actions[index]["tasks"][0]["taskID"]) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        } else if (a["type"] == ACTION_NAME.NOTIFY_SITE_TEAM_MEMBER) {
          if (a["role"] && JSON.stringify(a["role"]) != JSON.stringify(c_actions[index]["role"])) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        }
        index++;
      }

      if (conditions.length != c_conditions.length) {
        return this.updateDynamicSchedulePropertyValue(true);
      }

      index = 0;
      for (let c of conditions) {
        if (c["trigger"] != c_conditions[index]["trigger"]) {
          return this.updateDynamicSchedulePropertyValue(true);
        }

        if (c["trigger"] == TRIGGER_NAME.MILESTONE_COMPLETED) {
          if (c["milestones"] && JSON.stringify(c["milestones"]) != JSON.stringify(c_conditions[index]["milestones"])) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        } else if (c["trigger"] == TRIGGER_NAME.STEP_IN_ACTIVITY_COMPLETED) {
          if (c["responseOptionId"] != c_conditions[index]["responseOptionId"] || c["anyResponse"] != c_conditions[index]["anyResponse"] || c["noResponse"] != c_conditions[index]["noResponse"]) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        } else if (c["trigger"] == TRIGGER_NAME.PARTICIPANT) {
          if (c["field"] != c_conditions[index]["field"]) {
            return this.updateDynamicSchedulePropertyValue(true);
          }

          switch (c["field"]) {
            case "dob":
            case "dobWithMonthYear":
            case "dobWithYear":
              if (c["operator"] != c_conditions[index]["operator"] || c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
            case "country":
              if (c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
            case "gender":
              if (c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
            case "language":
              if (c["operator"] != c_conditions[index]["operator"] || c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
            case "ageRange":
              if (c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
          }
        }
        index++;
      }

      if (scheduling["type"] != c_scheduling["type"]) {
        return this.updateDynamicSchedulePropertyValue(true);
      } else if (scheduling["type"] === SCHEDULINGS_NAME.MILESTONE) {
        if (JSON.stringify(scheduling["milestones"]) != JSON.stringify(c_scheduling["milestones"])) {
          return this.updateDynamicSchedulePropertyValue(true);
        }
      } else if (scheduling["type"] === SCHEDULINGS_NAME.NO_OF_DAYS) {
        if (scheduling["completionWindow"] != c_scheduling["completionWindow"] || scheduling["days"] != c_scheduling["days"]) {
          return this.updateDynamicSchedulePropertyValue(true);
        }
      } else if (scheduling["type"] === SCHEDULINGS_NAME.CUSTOM) {
        if (scheduling["frequency"]["type"] != c_scheduling["frequency"]["type"] || scheduling["completionWindow"] != c_scheduling["completionWindow"]) {
          return this.updateDynamicSchedulePropertyValue(true);
        }
      }

      return this.dynamicScheduleUpdated;
    },
    checkIfAnyDynamicSchedulesChanged(constantScheduleList, changedScheduleList) {
      for (let i = 0; i < changedScheduleList.length; i++) {
        this.dynamicScheduleUpdated = false;

        let changedSchedule = changedScheduleList[i];
        if (!changedSchedule.dynamicSchedulingId) {
          /* New Dynamic Schedule is added */
          changedScheduleList[i]["dynamicScheduleUpdated"] = true;
          continue;
        }
        let singleChangedScheduleObj = constantScheduleList.filter(obj => {
          return obj.dynamicSchedulingId === changedScheduleList[i].dynamicSchedulingId;
        });

        changedScheduleList[i]["dynamicScheduleUpdated"] = this.checkIfDynamicScheduleChanged(singleChangedScheduleObj[0], changedScheduleList[i]);
      }

      return changedScheduleList;
    },
    filterSchedulerMilestonesForSaving(milestones) {
      let offsettedMilestones = _.cloneDeep(milestones);
      for (let i = 0; i < offsettedMilestones.length; i++) {
        offsettedMilestones[i] += this.studyData.screeningDuration;
      }
      return offsettedMilestones;
    },
    filterSchedulerMilestonesForDisplay(milestones) {
      let duration = this.studyData.screeningDuration;
      for (let i = 0; i < milestones.length; i++) {
        milestones[i] -= duration;
      }
      return milestones;
    },
    filteredCompletionWindowsForSaving(completionWindows) {
      let newCompletion = {};

      Object.keys(completionWindows).forEach(key => {
        let newKey = Number(key) + Number(this.studyData.screeningDuration);
        newCompletion[newKey] = Number(completionWindows[key]);
      });

      return newCompletion;
    },
    filteredCompletionWindowsForDisplay(completionWindows) {
      let newCompletion = {};

      Object.keys(completionWindows).forEach(key => {
        let newKey = Number(key) - Number(this.studyData.screeningDuration);
        newCompletion[newKey] = Number(completionWindows[key]);
      });

      return newCompletion;
    },
    isDateOfBirth(key) {
      return key === "dob" || key === "birthDate" || key === "dobWithMonthYear" || key === "dobWithYear";
    },
    checkValidation(originalScheduler, autoSave = false) {
      const scheduler = { ...originalScheduler };
      /* Only for 'Dynamic Only' activities - Start; this code will dis-allow a change in activity type from 'Dynamic Only' activities. */
      if (this.surveyDetails && this.surveyDetails.scheduler && this.surveyDetails.scheduler.activitySchedulingMode === MODE.dynamicOnly && this.surveyDetails.scheduler.activitySchedulingMode !== this.options.activityMode) {
        if (this.dynamicScheduleActivityAssociation.length) {
          let associatedActivityNames = this.convertArrayToText(this.dynamicScheduleActivityAssociation);
          if (!autoSave) {
            toastr.error(`The scheduling method for this activity cannot be changed because it is already associated with a Dynamic Scheduling record that includes ${associatedActivityNames}.`);
          }
          return;
        }
      }
      /* Only for 'Dynamic Only' activities - End */

      scheduler["dynamicScheduling"] = this.getDynamicActivitySchedules;
      if (scheduler["dynamicScheduling"] && scheduler["dynamicScheduling"].length) {
        for (let i = 0; i < scheduler["dynamicScheduling"].length; i++) {
          if (scheduler["dynamicScheduling"][i]["scheduling"][0].type === SCHEDULINGS_NAME.MILESTONE || scheduler["dynamicScheduling"][i]["scheduling"][0].type === SCHEDULINGS_NAME.CUSTOM) {
            scheduler["dynamicScheduling"][i]["scheduling"][0]["allowUntillDuration"] = scheduler["allowUntillDuration"];
            scheduler["dynamicScheduling"][i]["scheduling"][0]["showDailySummary"] = scheduler["showDailySummary"];
            scheduler["dynamicScheduling"][i]["scheduling"][0]["sequence"] = i + 1;
          }
          for (let condt of scheduler["dynamicScheduling"][i]["conditions"]) {
            if (condt["trigger"] === TRIGGER_NAME.PARTICIPANT && this.isDateOfBirth(condt.field)) {
              condt["field"] = condt.field === "dob" || condt.field === "birthDate" ? "dob" : condt.field;
              // For dates in DD/MM/YYYY; no conversion required, but for dates in 'DD MM YYYY'; needs conversion to DD/MM/YYYY. PS- dates are never null here.
              condt["value"] = condt["value"].indexOf("/") > -1 ? condt["value"] : moment(condt["value"], "DD MMM YYYY").format("DD/MM/YYYY");
            }
          }
        }
        scheduler["dynamicScheduling"] = this.checkIfAnyDynamicSchedulesChanged(this.getConstantDynamicActivitySchedulesData, scheduler["dynamicScheduling"]);
      }
      scheduler.taskId = this.surveyId ? this.surveyId : "";
      scheduler.taskType = this.options.validateFor;
      scheduler.activitySchedulingMode = this.options.activityMode;
      // When activity is scheduled for "onDemand"
      if ((this.options.activityMode && this.options.activityMode === "onDemand") || this.options.activityMode === "dynamicOnly") {
        scheduler["dynamicScheduling"] = null;
        this.$store.dispatch("addSchedule", {
          validatedFor: this.options.validateFor,
          schedulerObj: scheduler
        });
        return;
      }
      let milestoneArr = [];
      let minDiff = null;
      let validTime = true;
      let validMsg = true;
      let possibleVal = null;
      let validScheduler = true;
      let duplicated = null;
      let allDaysList = null;
      let properList = null;
      let durationValues = null;
      scheduler.completionWindow = scheduler.completionWindow ? Number(scheduler.completionWindow) : null;
      if (this.options.validateFor === "telehealth") {
        scheduler.advanceScheduleDays = scheduler.advanceScheduleDays || scheduler.advanceScheduleDays === 0 ? Number(scheduler.advanceScheduleDays) : null;
        scheduler.taskId = this.taskId;
      }
      const remindersActual = _.filter(this.reminderList, o => o.day !== "default");
      _.forEach(remindersActual, val => {
        if (!val.time.hh || !val.time.mm || !val.time.A) {
          validTime = false;
        }
        if (!val.message) {
          validMsg = false;
        }
      });
      const tempReminder = _.cloneDeep(remindersActual);
      tempReminder.forEach(val => {
        val.time = val.time.hh + ":" + val.time.mm + " " + val.time.A; //eslint-disable-line
      });
      const remindersWithOutMsg = _.map(remindersActual, object => _.pick(object, ["time", "day"]));
      duplicated = _.uniqWith(remindersWithOutMsg, _.isEqual);
      if (duplicated.length < remindersActual.length) {
        if (!autoSave) {
          toastr.error("One of the notification is configured on the same day and same time");
        }
      } else if (!validMsg) {
        if (!autoSave) {
          toastr.error("Enter notification message");
        }
      } else if (!validTime) {
        if (!autoSave) {
          toastr.error("Select notification time");
        }
      } else {
        scheduler.reminders = _.filter(tempReminder, o => o.day !== "default");
        scheduler.taskType = this.options.validateFor === "telehealth" ? "truclinic" : scheduler.taskType;
        if (this.options.validateFor === "telehealth") {
          scheduler.taskTitle = "Schedule Your Video Call with the Study Doctor";
        }

        switch (scheduler.type) {
          case "milestone":
            let clonedScheduler = _.cloneDeep(scheduler);

            if (this.studyData.milestonesList && this.studyData.screeningMilestoneAllowed) {
              let list = this.studyData.milestonesList.filter(mile => mile.milestoneType == "screening");
              let duration = this.studyData.screeningDuration;

              if (this.validateMilestones(list, duration, "screening") !== true) {
                return;
              }
            }

            if (this.studyData.milestonesList && !!this.studyData.milestonesList) {
              let list = this.studyData.milestonesList.filter(mile => mile.milestoneType != "screening");
              let duration = this.studyData.studyDuration;

              if (this.validateMilestones(list, duration, "") !== true) {
                return;
              }
            }
            if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
              clonedScheduler.milestones = this.filterSchedulerMilestonesForSaving(scheduler.milestones);
              clonedScheduler.completionWindows = this.filteredCompletionWindowsForSaving(scheduler.completionWindows);
            }

            if (clonedScheduler.milestones && clonedScheduler.milestones.length > 0) {
              let milestonesData = "";
              clonedScheduler.milestones.forEach(schedulerData => {
                milestonesData = schedulerData;
                this.studyData.milestones.forEach(studymilestones => {
                  if (studymilestones == milestonesData) {
                    this.finalMilestoneCount.push(studymilestones);
                  }
                });
              });
            }
            if (!clonedScheduler.milestones || clonedScheduler.milestones.length <= 0 || this.finalMilestoneCount.length == 0) {
              if (!autoSave) {
                toastr.error("Please select a milestone");
              }
              validScheduler = false;
            } else if (clonedScheduler.milestones.length === 1) {
              possibleVal = this.studyDuration - clonedScheduler.milestones[0] - 1;
              possibleVal = possibleVal === 0 ? 1 : possibleVal;
              if (clonedScheduler.taskType === "truclinic" && clonedScheduler.advanceScheduleDays > 99) {
                validScheduler = false;
                if (!autoSave) {
                  toastr.error("Advanced days cannot be more than 99");
                }
              }
            } else if (clonedScheduler.taskType === "truclinic" && (clonedScheduler.advanceScheduleDays === null || clonedScheduler.advanceScheduleDays === undefined)) {
              validScheduler = false;
              if (!autoSave) {
                toastr.error("Please enter value for advanced days");
              }
            } else {
              milestoneArr = _.map(clonedScheduler.milestones, _.ary(parseInt, 1));
              milestoneArr.sort();
              minDiff = this.findMinDiff(milestoneArr);
              possibleVal = minDiff;
              possibleVal = possibleVal === 0 ? 1 : possibleVal;
            }

            if (validScheduler && clonedScheduler.taskType === "truclinic" && !this.validateMilestoneType(possibleVal, validScheduler, clonedScheduler, milestoneArr, clonedScheduler.milestones)) {
              validScheduler = false;
            }
            if (validScheduler) {
              this.$store.dispatch("addSchedule", {
                validatedFor: this.options.validateFor,
                schedulerObj: clonedScheduler
              });
            }
            break;
          case "custom":
            this.$validator.validateAll().then(valid => {
              scheduler.frequency = scheduler.frequency ? scheduler.frequency : { type: null, title: null, days: null, segmentId: null };
              durationValues = _.map(scheduler.duration, item => ({
                startDay: item.startDay,
                endDay: item.endDay
              }));
              allDaysList = _.flatten(_.map(durationValues, o => [o.startDay, o.endDay]));
              properList = _.compact(allDaysList);
              properList = scheduler.allowUntillDuration && properList % 2 === 0 ? _.dropRight(properList) : properList;
              if (scheduler.taskType !== "notification" && (!scheduler.frequency.type || !scheduler.completionWindow)) {
                if (!autoSave) {
                  toastr.error(!scheduler.frequency.type ? "Please select a frequency" : "Please specify completion window.");
                }
              } else if (scheduler.taskType === "notification" && !scheduler.frequency.type) {
                if (!autoSave) {
                  toastr.error("Please select a frequency");
                }
              } else if (scheduler.taskType !== "notification" && (scheduler.completionWindow <= 0 || scheduler.completionWindow % 1 !== 0)) {
                if (!autoSave) {
                  toastr.error("Completion window should be greater than 0 and cannot have decimals.");
                }
              } else if (scheduler.taskType !== "notification" && scheduler.completionWindow > scheduler.frequency.days) {
                if (!autoSave) {
                  toastr.error("Completion window cannot exceed the length of the frequency.");
                }
              } else if (!scheduler.allowUntillDuration && allDaysList.length !== properList.length && !scheduler.allowUntillDuration && allDaysList.length !== properList.length - 1 && !this.studyData.screeningMilestoneAllowed) {
                if (!autoSave) {
                  toastr.error("Start and End days should be greater than 0 and cannot have decimals.");
                }
              } else if (this.studyData.screeningMilestoneAllowed && _.min(properList) < -this.studyData.screeningDuration) {
                if (!autoSave) {
                  toastr.error("Start Day cannot be less than screening Duration");
                }
              } else if (this.studyData.screeningMilestoneAllowed && durationValues[0].startDay < -this.studyData.screeningDuration && scheduler.allowUntillDuration) {
                if (!autoSave) {
                  toastr.error("Start Day cannot be less than screening Duration");
                }
              } else if (this.errors.any() && !valid && !this.studyData.screeningMilestoneAllowed) {
                if (!autoSave) {
                  toastr.error("Start and End days should be greater than 0 and cannot have decimals.");
                }
              } else if (!this.isSorted(properList)) {
                if (!autoSave) {
                  toastr.error("Start and end days should be in increasing order.");
                }
              } else if (_.uniq(properList).length !== properList.length) {
                if (!autoSave) {
                  toastr.error("Scheduled start and end days overlap. Please revise.");
                }
              } else if (_.max(properList) > this.studyDuration) {
                if (!autoSave) {
                  toastr.error("Start and end day should be less than study duration.");
                }
              } else if (scheduler.taskType === "truclinic" && (scheduler.advanceScheduleDays === null || scheduler.advanceScheduleDays === undefined)) {
                if (!autoSave) {
                  toastr.error("Please enter value for advance days.");
                }
              } else if (scheduler.taskType === "truclinic" && !this.validateCustomType(scheduler, properList)) {
                if (!autoSave) {
                  toastr.error("Invalid values");
                }
              } else if (this.isNumber()) {
                if (!autoSave) {
                  toastr.error("Please do not enter a decimal value for start day and end day.");
                }
              } else if (!scheduler.frequency.segmentId && !scheduler.frequency.segmentId == null) {
                toastr.error("Please select a cohort.");
              } else if (durationValues && !scheduler.allowUntillDuration && durationValues[0].startDay > durationValues[0].endDay) {
                if (!autoSave) {
                  toastr.error("Start and end days should be in increasing order.");
                }
              } else if (durationValues && (durationValues[0].startDay === "" || durationValues[0].endDay === "")) {
                if (!autoSave) {
                  toastr.error("Start and end days cannot be empty.");
                }
              } else {
                let checkStartDay = false;
                let checkEndtDay = false;

                if (this.getApiSchedular && !!this.segmentId && this.studyData.isSegmentSupported) {
                  this.getApiSchedular.duration.forEach(first => {
                    scheduler.duration.forEach(second => {
                      checkStartDay = this.findBetweenValue(first.startDay, first.endDay, second.startDay);
                      checkEndtDay = this.findBetweenValue(first.startDay, first.endDay, second.endDay);
                    });
                  });
                } else if (!this.segmentId && this.studyData.isSegmentSupported && this.getApiCohortSchedular) {
                  this.getApiCohortSchedular.forEach(data => {
                    data.duration.forEach(first => {
                      scheduler.duration.forEach(second => {
                        checkStartDay = this.findBetweenValue(first.startDay, first.endDay, second.startDay);
                        checkEndtDay = this.findBetweenValue(first.startDay, first.endDay, second.endDay);
                      });
                    });
                  });
                }

                if (checkStartDay || checkEndtDay) {
                  return toastr.error("Specified completion window overlaps with another cohort.");
                }

                if (this.studyData.screeningMilestoneAllowed) {
                  for (let day = 0; day < durationValues.length; day++) {
                    if (durationValues[day].startDay === null || durationValues[day].startDay === "" || isNaN(durationValues[day].startDay)) {
                      return toastr.error("Start and end days cannot be empty.");
                    } else if ((durationValues[day].startDay === null || durationValues[day].startDay === "") && (durationValues[day].endDay === null || durationValues[day].endDay === "") && !scheduler.allowUntillDuration) {
                      return toastr.error("Start and end days cannot be empty.");
                    } else if ((durationValues[day].startDay === null || durationValues[day].startDay === "") && scheduler.allowUntillDuration) {
                      return toastr.error("Start and end days cannot be empty.");
                    } else if (durationValues[day].startDay > durationValues[day].endDay && !scheduler.allowUntillDuration) {
                      return toastr.error("Start day should be greater than End day.");
                    } else if ((isNaN(durationValues[day].startDay) || isNaN(durationValues[day].endDay)) && !scheduler.allowUntillDuration) {
                      return toastr.error("Start and end days cannot be empty.");
                    } else if (durationValues[day].startDay === 0 && durationValues[day].endDay === 0 && !scheduler.allowUntillDuration) {
                      return toastr.error("Start and End days should be greater than 0 and cannot have decimals.");
                    } else if ((durationValues[day].endDay === null || durationValues[day].endDay === "") && !scheduler.allowUntillDuration) {
                      return toastr.error("Start and end days cannot be empty.");
                    }
                  }
                  let schedulerDurationCopy = [];
                  schedulerDurationCopy = _.cloneDeep(scheduler.duration);
                  schedulerDurationCopy.forEach(duration => {
                    Object.keys(duration).forEach(key => {
                      duration[key] += this.studyData.screeningDuration;
                    });
                  });
                  scheduler.duration = schedulerDurationCopy;
                }
                scheduler.segmentId = null;
                if (this.segmentId) {
                  scheduler.segmentId = this.segmentId;
                }
                this.$store.dispatch("addSchedule", {
                  validatedFor: this.options.validateFor,
                  schedulerObj: scheduler
                });
              }
            });
            break;
          default:
            break;
        }
      }
    },
    findBetweenValue(a, b, c) {
      let max, min;
      if (this.studyData.screeningMilestoneAllowed) {
        min = Math.min(Math, [a - this.studyData.screeningDuration, b - this.studyData.screeningDuration]);

        max = Math.max(Math, [a - this.studyData.screeningDuration, b - this.studyData.screeningDuration]);
      } else {
        min = Math.min(Math, [a, b]);

        max = Math.max(Math, [a, b]);
      }

      return c >= min && c <= max;
    },
    updateShowDailySummary() {
      if (!this.scheduler.allowMultipleTimes) {
        this.scheduler.showDailySummary = false;
      }
    },
    milestoneNotificationRemainder() {
      if (this.scheduler.milestones.length > 0) {
        let isCompletionwindowExist = _.isEmpty(this.scheduler.completionWindows);
        // Object.keys(this.scheduler.completionWindows).length !== 0
        //checking atleast one completionwindow having value or not.
        let isCompletionWindow = isCompletionwindowExist ? false : Object.values(this.scheduler.completionWindows).some(val => val !== "" && Number(val) > 0);
        if (isCompletionWindow) {
          let arr = Object.values(this.scheduler.completionWindows);
          this.isMilestoneNotification = true;
          //selecting maximum configured CompletionWindow value from all configured milestones.
          let maxCompletionWindowValue = Math.max(...arr);
          this.calculateReminders(maxCompletionWindowValue, null);
        } else {
          this.isMilestoneNotification = false;
        }
      } else {
        this.isMilestoneNotification = false;
      }
      //return this.isMilestoneNotification
    },
    getActivityAssociationInDynamicSchedules() {
      if (this.surveyDetails && this.surveyDetails.scheduler && this.surveyDetails.scheduler.activitySchedulingMode === MODE.dynamicOnly) {
        let params = {
          studyId: this.studyId,
          activityId: this.surveyId
        };
        this.$api.getActivityAssociationInDynamicSchedules(params).then(response => {
          this.dynamicScheduleActivityAssociation = response.body;
        });
      }
    },
    convertArrayToText(array) {
      /* Converts an array of strings to comma & 'and' separated String value. */
      let arrToStr = "";
      if (array.length === 1) {
        arrToStr = array[0];
      } else if (array.length === 2) {
        arrToStr = array[0] + " and " + array[1];
      } else {
        let lastElement = array.pop();
        arrToStr = array.join(", ") + " and " + lastElement;
      }
      return arrToStr;
    }
  }
};
</script>

<style scoped lang="scss">
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  margin-top: -1px;
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}

.bg-green {
  background-color: #2ecc71 !important;
}

.bg-red {
  background-color: #ff7171 !important;
}
.scheduler-heading {
  font-weight: 600;
  color: #666769;
}

.container-style {
  border-radius: 2px;
  background-color: #ffffff;
  color: #666769;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
.study_duration {
  display: inline-block;
  color: #4c8ce4;
  background-color: #edf3fc;
  padding: 2px 5px;
  border-radius: 2px;
}
.completion_window_days {
  width: 100px;
  display: inline-block;
}
.example {
  margin: 40px 40px 20px 40px;
}
.example-content {
  padding: 20px 40px 20px 40px;
}
.bg-milestone {
  background-color: #f5f8fa;
}
.example-header {
  padding: 20px 80px 10px 80px;
  font-weight: bold;
}

.milestone_box {
  border: 1px solid #34537d;
  width: 60px;
  height: 10px;
  padding-top: 1px;
  padding-bottom: 9px;
  border-radius: 100px;
  background-color: #34537d;
}
.disabled_frequency {
  pointer-events: none;
  background-color: #ddd !important;
}
.scheduler_types {
  margin-top: 8px;
  .scheduler_type {
    cursor: pointer;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 2px;
    min-height: 52px;
    display: inline-block;
    background-color: #fff;
  }
  .scheduler_type:not(:first-child) {
    margin-left: 10px;
  }
  .type_icon_bg {
    background-color: #ddd;
    width: 28px;
    height: 28px;
    display: inline-block;
    border-radius: 100%;
    padding: 3px;
    text-align: center;
  }
  .active_item {
    background-color: #32557a;
    color: #fff;
    .type_icon_bg {
      background-color: #488ee1;
    }
  }
}
.day_label {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #888;
  background-color: #fafafa;
  background-image: none;
  border: 1px solid #ccc;
}
.milestone {
  padding: 0px 12px 0px 120px;
}

.circle {
  width: 7px;
  height: 8px;
  background-color: white;
  border-radius: 100px;
  margin-left: 3px;
}
.completion-window {
  background-color: #c5d1d6;
  display: flex;
  padding: 0 4px;
  border-radius: 3px;
  padding: 8px 4px 4px 11px;
  margin-top: -4px;
}
.completion-window > p {
  padding-top: 8px;
  margin: 0;
  font-size: 12px;
  font-family: Roboto;
  line-height: 1.33;
  text-align: left;
  color: #34537d;
}
.completion-window > input {
  border: none;
  width: 50px;
  height: 32px;
  border-radius: 2px;
  text-align: center;
  background-color: #ffffff;
  color: #666669;
  padding: 5px;
}

.milestone_card {
  vertical-align: top;
  cursor: pointer;
  min-width: 160px;
  border: solid 1px #d3dfe4;
  background-color: #fff;
  border-radius: 2px;
  display: inline-block;
  padding: 8px 10px;
  margin: 13px 10px 10px 0;
  min-height: 52px;
}
.selected_completion_window {
  background-color: #32557a;
  border-radius: 4px;
  min-height: 52px;
  color: #fff;
  position: relative;
  vertical-align: top;
  min-width: 160px;
  border: solid 1px #d3dfe4;
  display: inline-block;
  margin: 13px 9px 10px 0;
  .fa {
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 32px;
    color: #488ee1;
  }
  .day_text {
    color: #ddd;
    font-size: 12px;
  }
  .day_card {
    padding: 10px 8px;
    min-width: 180px;
  }
}
.selected_milestone {
  background-color: #32557a;
  border-radius: 4px;
  min-height: 52px;
  color: #fff;
  position: relative;
  .fa {
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 32px;
    color: #488ee1;
  }
  .day_text {
    color: #ddd;
    font-size: 12px;
  }
}
.day_text {
  color: #999;
  font-size: 12px;
}
.edit_milestone_link {
  font-size: 12px;
  padding-left: 10px;
  position: relative;
  color: #4c8ce3;
  cursor: pointer;
}
.add_another_btn {
  font-size: 12px;
  background-color: #1e8fe1;
  border-color: #1e8fe1;
  color: #ffffff;
  margin-bottom: 20px;
  max-width: 120px;
}

.create_milestone_btn {
  font-size: 12px;
  background-color: #f06559;
  border-color: #f06559;
  color: #fff;
  margin-bottom: 20px;
  max-width: 180px;
}

.disabled-bg {
  pointer-events: none;
  // background-color: #e7ebef;
  /deep/ input {
    // color: red;
    background-color: #e7ebef;
  }
}
.time-picker input.display-time {
  background-color: #e7ebef;
  border-radius: 2px;
}
.pt-40 {
  padding-top: 40px;
}

.form-control {
  border-radius: 2px;
}

.text-color {
  color: #888;
}

.cancelImage {
  color: #959fa4;
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 24px;
}

.card {
  padding: 15px;
  color: black;
}

.display-day {
  height: 35px !important;
}

.input-color {
  background-color: #f7f7f7;
  border: 1px solid #cccccc;
  border-radius: 3px;
}

.checkbox_position {
  position: relative;
  top: 2px;
}

.view-screen {
  font-size: 10px;
  color: #4c8ce4;
  padding-left: 16px;
}

.opacity-change {
  opacity: 0.5;
}

.modal-dialog {
  max-width: 1000px !important;
}
.survey_notification_block {
  width: auto;
  height: auto;
  margin: 5px 31.5px 10px 0px;
  padding: 11px 23px 13px 19px;
  border-radius: 4px;
  border: solid 1px #c5d1d6;
}
.sub-heading-survey-notification {
  width: 230px;
  height: 20px;
  margin: 14px 47px 7px 0;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
  font-weight: 600;
}
.w100 {
  width: 100%;
}

.custom-noti-lab {
  opacity: 0.9;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
  font-family: "RobotoMedium";
}
.toggle-indicator {
  opacity: 0.8;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}

.xten {
  display: inline-block;
}
.add_a_notification_btn {
  background-color: #4c8ce4;
  font-family: "RobotoRegular";
  font-size: 12px;
  font-weight: normal !important;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  border-radius: 50px;
  padding: 1px 14px 0px 0px;
  height: auto !important;
  line-height: 24px !important;
}
.add_a_notification_btn:before {
  content: "\f055";
  font-family: "FontAwesome";
  color: white;
  font-size: 26px;
  float: left;
  padding: 0px 6px 0px 2px;
}
.cohortDrop {
  border-radius: 4px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
  pointer-events: none;
}
.CohortDIV:hover + .Cohort_hide {
  display: block;
}
.Cohort_hide {
  display: none;
  position: absolute;
  top: 16px;
}
.bt-1 {
  border-top: 1px solid #d3dfe4;
}
.notShownCSS {
  color: #4a4a4a;
  background-color: #eeeeee;
  padding: 2px;
  border-radius: 2px;
  font-family: Roboto;
  margin: -28px -11px 0px 0px;
  float: right;
  font-size: 10px;
}
.selectedNotShownCSS {
  margin: -20px 0px 0px 0px;
}
</style>
